import { RouterProvider } from "react-router-dom";
import { browserRouter } from "../config/routeConfig";

export default function Pages() {
  return <RouterProvider router={browserRouter} />;
}
